export default "__VITE_ASSET__CSK8aUtQ__"